import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTutorial = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9997 12.0527C13.5073 12.0527 14.7297 13.2747 14.7297 14.7821C14.7297 16.2902 13.5073 17.512 11.9997 17.512C10.492 17.512 9.26953 16.2902 9.26953 14.7821C9.26953 13.2747 10.492 12.0527 11.9997 12.0527Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3934 19.6968H11.6055V22.9722H12.3934V19.6968Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8262 19.8329L11.9997 17.7856L13.1733 19.8329H10.8262Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.48863 20.8516L5.93164 20.2939L8.24796 17.9775L8.80551 18.5353L6.48863 20.8516Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.59961 17.523L9.87712 16.9053L9.25927 19.1829L7.59961 17.523Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.0866 14.3882H3.81055V15.1765H7.0866V14.3882Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.94922 13.6089L8.99632 14.7824L6.94922 15.9565V13.6089Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.91788 11.8155L5.60156 9.49971L6.15849 8.94238L8.47543 11.2582L7.91788 11.8155Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.92919 10.6113L9.54704 12.889L7.26953 12.2713L8.92919 10.6113Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5122 20.8516L15.1953 18.5353L15.7529 17.9775L18.0691 20.2939L17.5122 20.8516Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4006 17.523L14.123 16.9053L14.7409 19.1829L16.4006 17.523Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.1901 14.3882H16.9141V15.1765H20.1901V14.3882Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.0493 13.6089L15.002 14.7824L17.0493 15.9565V13.6089Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7529 11.587L15.1953 11.0297L17.5122 8.71387L18.0691 9.27119L15.7529 11.587Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7409 10.3818L14.123 12.6595L16.4006 12.0418L14.7409 10.3818Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0009 23.2761C9.73255 23.2761 7.60017 22.3928 5.99558 20.7886C4.39127 19.1847 3.50781 17.0518 3.50781 14.7831C3.50781 12.515 4.39122 10.382 5.99558 8.77783L8.12346 10.9059C7.08813 11.9417 6.51769 13.3188 6.51769 14.7831C6.51769 16.248 7.08813 17.6249 8.12346 18.6608C9.15931 19.6964 10.5362 20.2668 12.0009 20.2668C13.4656 20.2668 14.8425 19.6964 15.8783 18.6608C18.0163 16.5227 18.0163 13.0442 15.8783 10.9059C15.4221 10.4498 14.8286 10.2118 14.1412 9.93574C12.6136 9.32289 10.5228 8.48381 10.0274 4.85292L13.0096 4.44629C13.2676 6.34282 13.9343 6.60984 15.2617 7.14292C16.0874 7.47378 17.1145 7.88615 18.0062 8.77772C19.6105 10.3819 20.494 12.5149 20.494 14.783C20.494 17.0517 19.6106 19.1846 18.0062 20.7885C16.4017 22.3928 14.2693 23.2761 12.0009 23.2761Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.3722 0.724121C11.3722 0.724121 10.3898 4.40918 9.18911 5.7742C7.98733 7.13906 12.355 4.08158 13.8291 5.63757C15.3037 7.19334 11.3722 0.724121 11.3722 0.724121Z",
			fill: "white"
		})
	]
});
export default SvgTutorial;
